<script>

import { totalScore } from './stores.js';
import { bpScore } from './stores.js';
import { pulseScore } from './stores.js';
import { tempScore } from './stores.js';
import { respScore } from './stores.js';
import { satScore } from './stores.js';

let scoreDetails = [
    { "tscore": 0,
      "number": 99507,
      "percentage": 61.74,
    },
    { "tscore": 1,
      "number": 41617,
      "percentage": 25.88,
    },
    { "tscore": 2,
      "number": 13426,
      "percentage": 8.35,
    },
    { "tscore": 3,
      "number": 4457,
      "percentage": 2.67,
    },
    { "tscore": 4,
      "number": 1448,
      "percentage": 0.9,
    },
    { "tscore": 5,
      "number": 486,
      "percentage": 0.3,
    },
    { "tscore": 6,
      "number": 206,
      "percentage": 0.11,
    },
    { "tscore": 7,
      "number": 65,
      "percentage": 0.04,
    },
    { "tscore": 8,
      "number": 25,
      "percentage": 0.014,
    }
];

let vitalDetails = [
    { "vital": "blood_pressure",
      "percentage": 0.56,
    },
    { "vital": "pulse",
      "percentage": 0.24,
    },
    { "vital": "resp",
      "percentage": 0.15,
    },
    { "vital": "sat",
    "percentage": 0.16,
    }
];

</script>

<body>
<section>
<div>
          {#each scoreDetails as {tscore, number, percentage}} 
          {#if $totalScore == tscore}
              <h2><b>{percentage}%</b> of sampled patients had a total severity score of {$totalScore}</h2>
          {/if}
          {/each}

        <div>
          {#if $totalScore > 8}
              <h3 class="red">Less than 0.02% of sampled patients had a score &ge; 8.</h3>  
              <p>Unless the clinical context suggests otherwise, escalation to an appropriate setting is strongly advised.</p>
          {:else if $totalScore > 6}
              <h3 class="red">Patients with a total score of 7 or higher have an increased chance of requiring urgent management. Consider escalation to a more appropriate setting depending on the clinical context.</h3>
          {/if}

          {#if $bpScore == 3 || $pulseScore == 3 || $satScore == 3 || $respScore == 3 || tempScore ==3 }
                {#if $totalScore <7}
                <p>An individual vital sign score of 3 is considered moderate severity by default</p>
                {/if}
              {#if $bpScore === 3} 
                <hr>
                <h4>Blood Pressure</h4>
                <p>{vitalDetails[0].percentage}% of patients had a blood pressure score of 3.</p>
              {/if}
              {#if $pulseScore === 3} 
                <hr>
                <h4>Pulse</h4>
                <p>{vitalDetails[1].percentage}% of patients had a pulse score of 3.</p>
              {/if}
              {#if $satScore === 3} 
                <hr>
                <h4>O2 Saturation</h4>
                <p>{vitalDetails[3].percentage}% of patients had an oxygen saturation score of 3.</p>
              {/if}
              {#if $tempScore === 3}
                <hr>
                <h4>Low Temperature</h4>
              {/if}
              {#if $respScore === 3} 
                <hr>
                <h4>Respiratory Rate</h4>
                <p>{vitalDetails[2].percentage}% of patients had a RR score of 3.</p>
              {/if}
              
          {:else if $totalScore >4}
          <h3 class="orange">Patients with a total score of 5 or higher may require additional evaluation and management. Consider referral depending on the clinical context.</h3>
          {:else}
          <h3>Consider clinical context</h3>
          {/if}    
          <br>
          <br>
          <br>
          <p>Percentages based on sample of 160,000 randomly selected ambulatory clinic visits in 2022</p>    
          
          
            
          
        </div>
    </div>    
</section>
</body>

<style>

section {
		font-family: bebas-neue-by-fontfabric, sans-serif;
		font-weight: 400;
		font-style: normal;
    align-items: center;
    justify-content: center;
    text-align: left;
    padding: 15px;
}

b {
  color: #00afaa;
}

h1 {
  font-size: 2rem;
  text-align: center;
}

.yellow {
    color: rgb(181, 181, 15);
 }
 .orange {
	color: rgb(239, 135, 9);
}

.red {
	color: rgb(126, 5, 5);
}
    
</style>